import { render, staticRenderFns } from "./WorkspaceForm.vue?vue&type=template&id=1174aaf0&scoped=true"
import script from "./WorkspaceForm.vue?vue&type=script&lang=js"
export * from "./WorkspaceForm.vue?vue&type=script&lang=js"
import style0 from "./WorkspaceForm.vue?vue&type=style&index=0&id=1174aaf0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1174aaf0",
  null
  
)

export default component.exports